module.exports = __webpack_public_path__ + "static/media/social_03.1bd1443b.jpg";